import { fromJS, Map } from 'immutable';
import config from '../../../config';
import actions from '../../constants/portal/institutions';
import {checkJsonResponse, logErrorConsole} from 'utils/actions';

const checkSearchFilter = filter => {
  if(filter) return `&search=${filter}`
  return ''
}

const checkFirstSearchFilter = filter => {
  if(filter) return `?search=${filter}`
  return ''
}

const checkRoleFilter = role => {
  if(role) return `&${role}=true`
  return ''
}

const checkFirstRoleFilter = level => {
  if(level) return `?hierarchy_level=${level}`
  return ''
}

const checkAdminFilter = id => {
  if(id) return `&admin_user=${id}`
  return ''
}

export const institutionsIsLoading = (data) => ({
  type: actions.INSTITUTIONS_IS_LOADING,
  data
});

export const currentUserInstitutionsIsLoading = (data) => ({
  type: actions.CURRENT_USER_INSTITUTIONS_IS_LOADING,
  data
});

export const subordinateInstitutionsIsLoading = (data) => ({
  type: actions.SUBORDINATE_IS_LOADING,
  data
});

export const institutionsIsLoaded = (data) => ({
  type: actions.INSTITUTIONS_IS_LOADED,
  data
});

export const cleanInstitutionPersonalDetails = () => ({
  type: actions.CLEAN_INSTITUTION_PERSONAL_DETAIL
})

export const cleanInstitutionServiceDetails = () => ({
  type: actions.CLEAN_INSTITUTION_SERVICE_DETAIL
})

export const cleanCurrentUserInstitutions = () => ({
  type: actions.CLEAN_CURRENT_USER_INSTITUTIONS
});

export const loadInstitutionType = () => (dispatch, getState) => {
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  dispatch(institutionsIsLoading(true));
  fetch(`${config.apiHost}/institution_type/`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_MEDICAL_INSTITUTIONS,
      data
    });
    dispatch(institutionsIsLoading(false))
  })
  .catch(logErrorConsole)
};

export const allTypesAreLoading = (data) => ({
  type: actions.ALL_TYPES_ARE_LOADING,
  data
});

export const loadAllTypes = level => (dispatch, getState) => {
  dispatch(allTypesAreLoading(true));
  fetch(`${config.apiHost}/institution_type/${checkFirstRoleFilter(level)}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_ALL_TYPES,
      data
    });
  })
  .catch(logErrorConsole)
  .then(()=> {
    dispatch(allTypesAreLoading(false))
  })
};


export const loadMedicalInstitutions = (administration="", search) => (dispatch) => {
  dispatch(institutionsIsLoading(true));
  return fetch(`${config.apiHost}/institution/?administration=${administration}${checkSearchFilter(search)}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_MEDICAL_INSTITUTIONS,
      data
    });
    dispatch(institutionsIsLoading(false))
    return data;
  })
  .catch(logErrorConsole)
};

export const searchMedicalInstitutions = search => (dispatch) => {
  dispatch(institutionsIsLoading(true));
  return fetch(`${config.apiHost}/institution/?search=${search}`)
    .then(checkJsonResponse)
    .then((json) => {
      const data = fromJS(json);
      dispatch({
        type: actions.LOAD_MEDICAL_INSTITUTIONS,
        data
      });
      dispatch(institutionsIsLoading(false))
      return data
    })
    .catch(logErrorConsole)
};

export const loadMedicalInstitutionsWithoutThirdLevel = (search, limit=200, offset=0) => (dispatch) => {
  dispatch(institutionsIsLoading(true));
  return fetch(`${config.apiHost}/institution/?hierarchy_level=&hierarchy_level__lte=2${checkSearchFilter(search)}&limit=${limit}&offset=${offset}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_MEDICAL_INSTITUTIONS,
      data
    });
    dispatch(institutionsIsLoading(false))
    return data
  })
  .catch(logErrorConsole)
};

export const loadMedicalInstitutionsCabinet = (record='', search='') => (dispatch, getState) => {
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  dispatch(institutionsIsLoading(true));
  return fetch(`${config.apiHost}/institution/?record_model=${record}${checkSearchFilter(search)}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_MEDICAL_INSTITUTIONS,
      data
    });
    dispatch(institutionsIsLoading(false))
    return data
  })
  .catch(logErrorConsole)
};

export const institutionsSubordinateListIsLoading = (data) => ({
  type: actions.SUBORDINATE_INSTITUTIONS_IS_LOADING,
  data
});


export const loadSubordinateInstitutions = (id, limit, offset) => (dispatch) => {
  dispatch(institutionsSubordinateListIsLoading(true));
  fetch(`${config.apiHost}/institution/?parent=${id}&limit=${limit}&offset=${offset}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_SUBORDINATE_INSTITUTIONS,
      data
    });
  })
  .catch(logErrorConsole)
  .then(() => {
    dispatch(institutionsSubordinateListIsLoading(false))
  })
};

export const searchSubordinateInstitutions = (name="", id, limit, offset) => (dispatch) => {
  dispatch(institutionsSubordinateListIsLoading(true));
  fetch(`${config.apiHost}/institution/?parent=${id}&limit=${limit}&offset=${offset}${checkSearchFilter(name)}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_SUBORDINATE_INSTITUTIONS,
      data
    });
    dispatch(institutionsSubordinateListIsLoading(false))
  })
  .catch(logErrorConsole)
};

export const searchInstitutions = (name, limit, offset) => (dispatch) => {
  dispatch(institutionsIsLoading(true));
  fetch(`${config.apiHost}/institution/?limit=${limit}&offset=${offset}&institution_type_not=${'020100'}${checkSearchFilter(name)}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_MEDICAL_INSTITUTIONS,
      data
    });
    dispatch(institutionsIsLoading(false))
  })
  .catch(logErrorConsole)
};

/// admin

export const searchInstitutionsByLevel = (name, type='', level, limit, offset, adminId) => (dispatch) => {
  dispatch(institutionsIsLoading(true));
  fetch(`${config.apiHost}/institution/?hierarchy_level__lte=${level}&limit=${limit}&offset=${offset}&institution_type=${type}${checkAdminFilter(adminId)}${checkSearchFilter(name)}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_MEDICAL_INSTITUTIONS,
      data
    });
    dispatch(institutionsIsLoading(false))
  })
  .catch(logErrorConsole)
};

export const searchInstitutionsByLevelWithoutCivil = (name, type='', level, limit, offset, adminId) => (dispatch) => {
  dispatch(institutionsIsLoading(true));
  fetch(`${config.apiHost}/institution/?hierarchy_level__lte=${level}&limit=${limit}&offset=${offset}&institution_type=${type}&institution_mask=01${checkAdminFilter(adminId)}${checkSearchFilter(name)}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_MEDICAL_INSTITUTIONS,
      data
    });
    dispatch(institutionsIsLoading(false))
  })
  .catch(logErrorConsole)
};



export const loadInstitutionByType = (mask, limit=25, offset=0) => (dispatch) => {
  dispatch(institutionsIsLoading(true));
  fetch(`${config.apiHost}/institution/?institution_mask=${mask}&institution_type_not=020000&limit=${limit}&offset=${offset}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_MEDICAL_INSTITUTIONS,
      data
    });
    dispatch(institutionsIsLoading(false))
  })
  .catch(logErrorConsole)
  };

export const loadInstitutionDetail = (id) => (dispatch) => {
  return fetch(`${config.apiHost}/institution/${id}/`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_INSTITUTION_DETAIL,
      data
    });

  })
  .catch(logErrorConsole)
};

export const onLoadParentByParentProperty = (parent) => (dispatch) => {
  return fetch(`${config.apiHost}/institution/${parent}/`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_INSTITUTION_PARENT,
      data
    })
    console.log('loadParentByProp, 1st data', data)
    return data
  })
  .catch(logErrorConsole)
  .then((data) => {
    console.log('loadParentByProp, 2nd data', data)
    return data
  })
};



export const loadInstitutionPersonal = (id, model="") => (dispatch) => {
  dispatch(institutionsIsLoading(true));
  fetch(`${config.apiHost}/staff/?institution=${id}&record_model=${model}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_INSTITUTION_PERSONAL,
      data
    });
    dispatch(institutionsIsLoading(false));
  })
  .catch(e => console.log(e))
};

export const loadInstitutionPersonalById = (id, limit, offset) => (dispatch) => {
  dispatch(institutionsIsLoading(true));
  fetch(`${config.apiHost}/staff/?institution=${id}&limit=${limit}&offset=${offset}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_INSTITUTION_PERSONAL,
      data
    });
    dispatch(institutionsIsLoading(false));
  })
  .catch(e => console.log(e))
};

export const loadInstitutionPersonalCabinet = (model="", search='') => (dispatch, getState) => {
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  dispatch(institutionsIsLoading(true));
  return fetch(`${config.apiHost}/staff/?record_model=${model}${checkSearchFilter(search)}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json.results);
    dispatch({
      type: actions.LOAD_INSTITUTION_PERSONAL,
      data
    });
    dispatch(institutionsIsLoading(false));
    return data
  })
  .catch(e => console.log(e))
};


export const loadInstitutionParentPersonal = (id, search) => (dispatch) => {
  dispatch(institutionsIsLoading(true));
  return fetch(`${config.apiHost}/staff/?administration=${id}${checkSearchFilter(search)}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json.results);
    dispatch({
      type: actions.LOAD_INSTITUTION_PERSONAL,
      data
    });
    dispatch(institutionsIsLoading(false));
    return data
  })
  .catch(e => console.log(e))
};

export const loadAllStaff = () => (dispatch) => {
  dispatch(institutionsIsLoading(true));
  fetch(`${config.apiHost}/staff/`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_INSTITUTION_PERSONAL,
      data
    });
    dispatch(institutionsIsLoading(false));
  })
  .catch(e => console.log(e))
};

export const loadStaffByType = (type, institution, limit=25, offset=0) => (dispatch) => {
  dispatch(institutionsIsLoading(true));
  fetch(`${config.apiHost}/staff/?personal_type=${type}&institution=${institution}&limit=${limit}&offset=${offset}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_INSTITUTION_PERSONAL,
      data
    });
    dispatch(institutionsIsLoading(false));
  })
  .catch(e => console.log(e))
};

export const loadStaffByTypes = (types, institution) => (dispatch) => {
  dispatch(institutionsIsLoading(true));
  fetch(`${config.apiHost}/staff/?personal_type__in=${types}&institution=${institution}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_INSTITUTION_PERSONAL,
      data
    });
    dispatch(institutionsIsLoading(false));
  })
  .catch(e => console.log(e))
};


export const searchInstitutionPersonal = (id, name, limit, offset) => (dispatch) => {
  dispatch(institutionsIsLoading(true));
  fetch(`${config.apiHost}/staff/?institution=${id}&limit=${limit}&offset=${offset}${checkSearchFilter(name)}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_INSTITUTION_PERSONAL,
      data
    });
    dispatch(institutionsIsLoading(false));
  })
  .catch(e => console.log(e))
};



export const searchAllPersonal = (name, institution="", profession="", type, limit=25, offset=0) => (dispatch) => {
  dispatch(institutionsIsLoading(true));
  fetch(`${config.apiHost}/staff/?search=${name}&institution__isnull=false&institution=${institution}&doctor__profession_classification=${profession}&personal_type=${type}&limit=${limit}&offset=${offset}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_INSTITUTION_PERSONAL,
      data
    });
    dispatch(institutionsIsLoaded(true));
    dispatch(institutionsIsLoading(false));
  })
  .catch(e => console.log(e))
};

export const loadClasifications = search => (dispatch) => {
  return fetch(`${config.apiHost}/profession_classification/${checkFirstSearchFilter(search)}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json.results);
    dispatch({
      type: actions.LOAD_PROFESSION_CLASSIFICATION,
      data
    });
    return data
  })
  .catch(e => console.log(e))
};

export const loadInstitutionPersonalDetail = (id) => (dispatch) => {
  dispatch(institutionsIsLoading(true));
  fetch(`${config.apiHost}/staff/${id}/`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_INSTITUTION_PERSONAL_DETAIL,
      data
    });
    dispatch(institutionsIsLoading(false));
  })
  .catch(logErrorConsole)
};

export const loadStaffByUser = (id, role) => (dispatch) => {
  dispatch(currentUserInstitutionsIsLoading(true));
  fetch(`${config.apiHost}/staff/?user=${id}${checkRoleFilter(role)}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_CURRENT_USER_INSTITUTIONS,
      data
    });
    dispatch(currentUserInstitutionsIsLoading(false));
  })
  .catch(logErrorConsole)
};


export const loadInstitutionServices = (id) => (dispatch) => {
  dispatch(institutionsIsLoading(true));
  fetch(`${config.apiHost}/institution_service/?institution=${id}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_INSTITUTION_SERVICES,
      data
    });
    dispatch(institutionsIsLoading(false));
  })
  .catch(logErrorConsole)
};

export const searchInstitutionServices = (id, name="", limit, offset) => (dispatch) => {
  dispatch(institutionsIsLoading(true));
  fetch(`${config.apiHost}/institution_service/?institution=${id}&search=${name}&limit=${limit}&offset=${offset}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_INSTITUTION_SERVICES,
      data
    });
    dispatch(institutionsIsLoading(false));
  })
  .catch(logErrorConsole)
};


export const loadInstitutionServiceDetail = (id) => (dispatch) => {
  dispatch(institutionsIsLoading(true));
  fetch(`${config.apiHost}/institution_service/${id}/`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_INSTITUTION_SERVICE_DETAIL,
      data
    });
    dispatch(institutionsIsLoading(false));
  })
  .catch(logErrorConsole)
};

export const changeAccostItem = (data) => ({
	type: actions.SET_ACCOST_ITEM,
	data
});

export const changeAccostValue = (data, key) => ({
	type: actions.SET_ACCOST_ITEM_VALUE,
	key,
	data
});

export const cleanAccostForm = () => ({
  type: actions.SET_ACCOST_ITEM,
  data: new Map({
    brief_description: '',
    detail_description: '',
  })
})

export const submitAccost = (staff_id, institution_id, user_id, type) => (dispatch, getState) => {
  const options = {
    method : "post",
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
      "Content-type": 'application/json'
    },
    body: JSON.stringify({
      staff: staff_id,
      institution: institution_id,
      user: user_id,
      type: type,
      brief_description: getState().institutions.get('accost').get('brief_description'),
      detail_description: getState().institutions.get('accost').get('detail_description')
    })
  }
  fetch(`${config.apiHost}/accost/`, options)
  .then(checkJsonResponse)
  .then(json => {
    dispatch({
      type: actions.LOAD_ACCOST_DETAIL,
      data: fromJS(json)
    })
  })
  .catch(logErrorConsole)
};

export const submitInstitutionAccost = (institution_id, user_id, type) => (dispatch, getState) => {
  const options = {
    method : "post",
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
      "Content-type": 'application/json'
    },
    body: JSON.stringify({
      institution: institution_id,
      user: user_id,
      type: type,
      brief_description: getState().institutions.get('accost').get('brief_description'),
      detail_description: getState().institutions.get('accost').get('detail_description')
    })
  }
  fetch(`${config.apiHost}/accost/`, options)
  .then(checkJsonResponse)
  .then(json => {
    dispatch({
      type: actions.LOAD_ACCOST_DETAIL,
      data: fromJS(json)
    })
  })
  .catch(logErrorConsole)
};

export const loadAccostByUser = (id, limit, offset) => (dispatch, getState) => {
  dispatch(institutionsIsLoading(true));
  fetch(`${config.apiHost}/accost/?user=${id}&limit=${limit}&offset=${offset}`)
  .then(checkJsonResponse)
  .then(json => {
    dispatch({
      type: actions.LOAD_ACCOSTS,
      data: fromJS(json)
    })
    dispatch(institutionsIsLoading(false));
  })
  .catch(logErrorConsole)
}

export const searchRatingWithoutData = (staff_id, institution, mark, user="", limit, offset) => (dispatch, getState) => {
  dispatch(institutionsIsLoading(true));
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  fetch(`${config.apiHost}/rating/?staff=${staff_id}&institution=${institution}&rating=${mark}&user=${user}&limit=${limit}&offset=${offset}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);

    dispatch({
      type: actions.LOAD_RATING,
      data
    });
    dispatch(institutionsIsLoading(false));
  })
  .catch(logErrorConsole)
  .then(() => {
    dispatch(institutionsIsLoading(false));
  })
};


export const searchRating = (staff_id, administration, institution, start_date, end_date, mark, limit, offset) => (dispatch, getState) => {
  const date_start = start_date.format("YYYY-MM-DDTHH:mm:ss");
  const date_end = end_date.format("YYYY-MM-DDT23:59:59");
  dispatch(institutionsIsLoading(true));
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  fetch(`${config.apiHost}/rating/?staff=${staff_id}&administration=${administration}&institution=${institution}&rating=${mark}&date_created__range=${date_start}Z,${date_end}Z&limit=${limit}&offset=${offset}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);

    dispatch({
      type: actions.LOAD_RATING,
      data
    });
    dispatch(institutionsIsLoading(false));
  })
  .catch(logErrorConsole)
  .then(() => {
    dispatch(institutionsIsLoading(false));
  })
};

export const searchRatingByInstituion = (staff_id, institution, start_date, end_date, mark, limit, offset) => (dispatch, getState) => {
  const date_start = start_date.format("YYYY-MM-DDTHH:mm:ss");
  const date_end = end_date.format("YYYY-MM-DDT23:59:59");
  dispatch(institutionsIsLoading(true));
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  fetch(`${config.apiHost}/rating/?staff=${staff_id}&institution=${institution}&rating=${mark}&date_created__range=${date_start}Z,${date_end}Z&limit=${limit}&offset=${offset}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);

    dispatch({
      type: actions.LOAD_RATING,
      data
    });
    dispatch(institutionsIsLoading(false));
  })
  .catch(logErrorConsole)
  .then(() => {
    dispatch(institutionsIsLoading(false));
  })
};

export const searchAccostsWithoutData = (isNull, staff_id, institution, type, status, user="", limit, offset) => (dispatch, getState) => {
  dispatch(institutionsIsLoading(true));
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  fetch(`${config.apiHost}/accost/?staff__isnull=${isNull}&staff=${staff_id}&institution=${institution}&status=${status}&type=${type}&user=${user}&limit=${limit}&offset=${offset}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);

    dispatch({
      type: actions.LOAD_ACCOSTS,
      data
    });
    dispatch(institutionsIsLoading(false));
  })
  .catch(logErrorConsole)
  .then(() => {
    dispatch(institutionsIsLoading(false));
  })
};


export const searchAccosts = (isNull, staff_id, administration, institution, start_date, end_date, type, status, limit, offset) => (dispatch, getState) => {
  const date_start = start_date.format("YYYY-MM-DDTHH:mm:ss");
  const date_end = end_date.format("YYYY-MM-DDT23:59:59");
  dispatch(institutionsIsLoading(true));
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  fetch(`${config.apiHost}/accost/?staff__isnull=${isNull}&staff=${staff_id}&administration=${administration}&institution=${institution}&status=${status}&type=${type}&date_created__range=${date_start}Z,${date_end}Z&limit=${limit}&offset=${offset}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_ACCOSTS,
      data
    });
    dispatch(institutionsIsLoading(false));
  })
  .catch(logErrorConsole)
  .then(() => {
    dispatch(institutionsIsLoading(false));
  })
};


export const searchAccostsByInstitution = (isNull, staff_id, institution, start_date, end_date, type, status, limit, offset) => (dispatch, getState) => {
  const date_start = start_date.format("YYYY-MM-DDTHH:mm:ss");
  const date_end = end_date.format("YYYY-MM-DDT23:59:59");
  dispatch(institutionsIsLoading(true));
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  fetch(`${config.apiHost}/accost/?staff__isnull=${isNull}&staff=${staff_id}&institution=${institution}&status=${status}&type=${type}&date_created__range=${date_start}Z,${date_end}Z&limit=${limit}&offset=${offset}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_ACCOSTS,
      data
    });
    dispatch(institutionsIsLoading(false));
  })
  .catch(logErrorConsole)
  .then(() => {
    dispatch(institutionsIsLoading(false));
  })
};


export const loadAccostAll = (isNull, id, limit, offset) => (dispatch, getState) => {
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  dispatch(institutionsIsLoading(true));
  fetch(`${config.apiHost}/accost/?staff__isnull=${isNull}&user=${id}&limit=${limit}&offset=${offset}`, options)
   .then(checkJsonResponse)
    .then(json => {
      dispatch({
        type: actions.LOAD_ACCOSTS,
        data: fromJS(json)
      })
      dispatch(institutionsIsLoading(false));
    })
    .catch(logErrorConsole)
}

export const loadAccostDetail = (id) => (dispatch, getState) => {
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  fetch(`${config.apiHost}/accost/${id}/`, options)
  .then(checkJsonResponse)
  .then(json => {
    dispatch({
      type: actions.LOAD_ACCOST_DETAIL,
      data: fromJS(json)
    })
  })
  .catch(logErrorConsole)
};

export const changeAccostStatus = (id, status) => (dispatch, getState) => {
  const options = {
    method : "PATCH",
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
      "Content-type": 'application/json'
    },
    body: JSON.stringify({
      status: status
    })
  }
  fetch(`${config.apiHost}/accost/${id}/`, options)
  .then(checkJsonResponse)
  .then(json => {
    dispatch(loadAccostDetail(id))
  })
  .catch(logErrorConsole)
}

export const changeAccostAnswer = (id, answer) => (dispatch, getState) => {
  const options = {
    method : "PATCH",
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
      "Content-type": 'application/json'
    },
    body: JSON.stringify({
      answer: answer
    })
  }
  fetch(`${config.apiHost}/accost/${id}/`, options)
  .then(checkJsonResponse)
  .then(json => {
    dispatch(loadAccostDetail(id))
  })
  .catch(logErrorConsole)
}

export const submitRating = (staff_id, user_id, rating, comment) => (dispatch, getState) => {
  const options = {
    method : "post",
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
      "Content-type": 'application/json'
    },
    body: JSON.stringify({
      staff: staff_id,
      user: user_id,
      rating: rating,
      comment: comment
    })
  }
  fetch(`${config.apiHost}/rating/`, options)
  .then(checkJsonResponse)
  .then(json => {
    dispatch({
      type: actions.LOAD_RATING_DETAIL,
      data: fromJS(json)
    })
    dispatch(loadInstitutionPersonalDetail(staff_id))
  })
  .catch(logErrorConsole)
};

export const loadRating = (id, limit, offset) => (dispatch, getState) => {
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    }
  }
  dispatch(institutionsIsLoading(true));
  fetch(`${config.apiHost}/rating/?user=${id}&limit=${limit}&offset=${offset}`, options)
  .then(checkJsonResponse)
  .then(json => {
    dispatch({
      type: actions.LOAD_RATING,
      data: fromJS(json)
    })
    dispatch(institutionsIsLoading(false));
  })
  .catch(logErrorConsole)
};

export const checkRating = (user_id, staff_id) => (dispatch, getState) => {
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    }
  }
  fetch(`${config.apiHost}/rating/?user=${user_id}&staff=${staff_id}`, options)
  .then(checkJsonResponse)
  .then(json => {
    dispatch({
      type: actions.CHECK_RATING,
      data: fromJS(json)
    })
  })
  .catch(logErrorConsole)
};


export const loadRatingDetail = (id) => (dispatch, getState) => {
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    }
  }
  fetch(`${config.apiHost}/rating/${id}/`, options)
  .then(checkJsonResponse)
  .then(json => {
    dispatch({
      type: actions.LOAD_RATING_DETAIL,
      data: fromJS(json)
    })
  })
  .catch(logErrorConsole)
};

export const addAnswerToRating = (rating_id, answer) => (dispatch, getState) => {
  const options = {
    method : "PATCH",
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
      "Content-type": 'application/json'
    },
    body: JSON.stringify({
      answer: answer
    })
  }
  fetch(`${config.apiHost}/rating/${rating_id}/`, options)
  .then(checkJsonResponse)
  .then(response => {
    dispatch({
      type: actions.CHANGE_RATING_COMMENT,
      data: response.answer
    })
  })
  .catch(logErrorConsole)
};



// WEBPACK FOOTER //
// ./src/redux/actions/portal/institutions.js